import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  TextField,
  Select as MuiSelect,
  MenuItem,
  Checkbox,
  Button,
  Grid, IconButton, Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import MDButton from "components/MDButton";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { fetchJourneys } from "../../../../features/journey/journeyThunk";
import InitializeJourney from "./InializeJourney";
import DownloadIcon from "@mui/icons-material/Download";
import FileSaver from "file-saver";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const JourneyForm = ({ selectedJourney, onClearJourney, onEditStops }) => {
  const [journey, setJourney] = useState({
    thingId: "",
    journeyId: "",
    journeyState: "CREATED",
    journeyType: "PICKING",
    journeyStatus: true,
    etaAlerts: true,
    geofenceAlerts: true,
    updateAlerts: true,
    timeZone: "Asia/Kolkata",
    startTime: "06:00",
    endTime: "09:00",
    attendants: [],
    journeyName: "",
    workingDays: [],
  });

  const [isChangeThingOpen, setIsChangeThingOpen] = useState(false);
  const [newThingId, setNewThingId] = useState("");
  const [isInitializeOpen, setIsInitializeOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const selectedVehicle = useSelector((state) => state.vehicle.isVehicle);
  const dispatch = useDispatch();

  const { data: journeysData = {}, tempJourneys = {}, loading: journeyLoading, error: journeyError } =
    useSelector((state) => state.journey || {});

  useEffect(() => {
    const currentTime = new Date().toLocaleTimeString("en-US", {
      timeZone: "Asia/Kolkata",
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    });
    if (selectedJourney) {
      console.log("selectedjourneyy", selectedJourney);

      const updatedJourney = {
        thingId: selectedJourney.thingId || "",
        journeyId: selectedJourney.journeyId || "",
        journeyState: selectedJourney.state || "CREATED",
        journeyType: selectedJourney.type || "PICKING",
        // journeyStatus: selectedJourney.journeyStatus !== undefined ? selectedJourney.journeyStatus : true,
        journeyStatus:
          selectedJourney.disabled !== undefined
            ? !selectedJourney.disabled
            : true,
        etaAlerts: selectedJourney.disableEtaAlerts !== undefined ? !selectedJourney.disableEtaAlerts : true,
        geofenceAlerts: selectedJourney.disableGeoFenceAlerts !== undefined ? !selectedJourney.disableGeoFenceAlerts : true,
        updateAlerts: selectedJourney.disableUpdateAlerts !== undefined ? !selectedJourney.disableUpdateAlerts : true,
        timeZone: selectedJourney.timeZone || "Asia/Kolkata",

        startTime: selectedJourney?.interval?.startTime || "06:00",
        endTime: selectedJourney?.interval?.endTime || "09:00",

        attendants: selectedJourney.attendants || [],
        journeyName: selectedJourney.journeyName || "",

        workingDays: selectedJourney.workingDays || [
          "MONDAY",
          "TUESDAY",
          "WEDNESDAY",
          "THURSDAY",
          "FRIDAY",
          "SATURDAY",
        ],
      };

      setJourney(updatedJourney);
    } else {
      const initialJourney = {
        thingId: selectedVehicle || "",
        journeyId: "",
        journeyType: "PICKING",
        journeyStatus: true,
        timeZone: "Asia/Kolkata",
        startTime: "06:00",
        endTime: "09:00",
        attendants: [],
        journeyName: "",
        workingDays: [
          "MONDAY",
          "TUESDAY",
          "WEDNESDAY",
          "THURSDAY",
          "FRIDAY",
          "SATURDAY",
        ],
      };
      setJourney(initialJourney);
    }
  }, [selectedJourney, selectedVehicle]);

  // Helper function to calculate default end time (e.g., 4 hours after start time)
  const getDefaultEndTime = (startTime) => {
    const [startHours, startMinutes] = startTime.split(":").map(Number);
    let endHours = startHours + 4;
    let endMinutes = startMinutes;
    if (endHours >= 24) {
      endHours -= 24;
    }
    return `${String(endHours).padStart(2, "0")}:${String(endMinutes).padStart(2, "0")}`;
  };

  const handleToggleChange = (field) => {
    setJourney((prev) => {
      const newValue = !prev[field];
      return { ...prev, [field]: newValue };
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setJourney((prev) => ({ ...prev, [name]: value }));
  };

  const handleWorkingDaysChange = (day) => {
    setJourney((prev) => {
      const updatedDays = prev.workingDays.includes(day)
        ? prev.workingDays.filter((d) => d !== day)
        : [...prev.workingDays, day];
      return { ...prev, workingDays: updatedDays };
    });
  };

  const handleSubmit = async () => {
    const payload = {
      thingId: selectedVehicle,
      journeyId: journey.journeyId,
      journeyName: journey.journeyName,
      type: journey.journeyType,
      workingDays: journey.workingDays,
      attendants: journey.attendants,
      interval: {
        timeZone: journey.timeZone,
        startTime: journey.startTime,
        endTime: journey.endTime,
      },
      disabled: !journey.journeyStatus,
      disableEtaAlerts: !journey.etaAlerts,
      disableGeoFenceAlerts: !journey.geofenceAlerts,
      disableUpdateAlerts: !journey.updateAlerts,
    };

    try {
      const url = selectedJourney
        ? "https://v3.dhundhoo.com/journey/updateJourney"
        : "https://v3.dhundhoo.com/journey/createJourney";
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-dhundhoo-session": window.localStorage.getItem("token") || "session",
        },
        body: JSON.stringify(payload),
      });
      // if (response.ok) {
      //   const updatedJourneyData = await response.json();
      //   setJourney((prev) => ({
      //     ...prev,
      //     ...updatedJourneyData,
      //     startTime: updatedJourneyData.interval?.startTime || prev.startTime,
      //     endTime: updatedJourneyData.interval?.endTime || prev.endTime,
      //   }));
      //   toast.success(selectedJourney ? "Journey updated successfully" : "Journey created successfully");
      //   onClearJourney();
      // } 
      if (response.ok) {
        toast.success(
          selectedJourney
            ? "Journey updated successfully"
            : "Journey created successfully"
        );

        onClearJourney();
        dispatch(fetchJourneys(selectedVehicle));
      }
      else {
        toast.error("Failed to save journey");
      }
    } catch (error) {
      toast.error("Error " + (selectedJourney ? "updating" : "creating") + " journey");
    }
    dispatch(fetchJourneys(selectedVehicle));
  };

  const handleReInitialize = () => {
    setIsInitializeOpen(true);
  };

  const handleClearJourney = () => {
    onClearJourney();
  };

  const handleChangeThing = () => {
    setIsChangeThingOpen(true);
    setNewThingId("");
  };

  const handleDeleteJourney = async () => {

    setIsDeleteDialogOpen(false);

    if (!journey?.journeyId) {
      toast.error("No journey selected to delete");
      return;
    }

    try {
      const response = await fetch(
        `https://v3.dhundhoo.com/journey/remove/${journey.journeyId}`,
        {
          method: "GET",
          headers: {
            "x-dhundhoo-session": window.localStorage.getItem("token"),
          },
        }
      );

      if (response.ok) {
        toast.success("Journey deleted successfully");
        // Optionally refresh journey list
        dispatch(fetchJourneys(selectedVehicle));
        onClearJourney();
      } else {
        const errText = await response.text();
        toast.error(`Failed to delete journey: ${errText}`);
      }
    } catch (error) {
      console.error("Error deleting journey:", error);
      toast.error("Error deleting journey");
    }
  };


  const handleChangeThingConfirm = async () => {
    if (!newThingId) {
      toast.error("Please enter a new thing ID");
      return;
    }

    try {
      const response = await fetch(`https://v3.dhundhoo.com/journey/changeThing`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-dhundhoo-session": window.localStorage.getItem("token"),
        },
        body: JSON.stringify({ thingId: newThingId, journeyId: journey.journeyId }),
      });
      if (response.ok) {
        const updatedJourneyData = await response.json(); // Assuming API returns updated journey data
        setJourney((prev) => ({
          ...prev,
          ...updatedJourneyData, // Update with API response data
          startTime: updatedJourneyData.interval?.startTime || prev.startTime,
          endTime: updatedJourneyData.interval?.endTime || prev.endTime,
        }));
        toast.success("Thing changed successfully");
        setIsChangeThingOpen(false);
        dispatch(fetchJourneys(selectedVehicle));
      } else {
        toast.error("Failed to change thing");
      }
    } catch (error) {
      toast.error("Error changing thing");
    }
  };

  const handleChangeThingClose = () => {
    setIsChangeThingOpen(false);
    setNewThingId("");
  };

  const handleNewThingIdChange = (e) => {
    setNewThingId(e.target.value);
  };

  const handleInitializeSuccess = () => {
    setIsInitializeOpen(false); // Close the initialization dialog
    // toast.success("Journey initialized successfully");
    dispatch(fetchJourneys(selectedVehicle)); // Refresh journey data
  };

  const handleBack = () => {
    setIsInitializeOpen(false);
  };

  const handleCopyToAll = async () => {
    if (!journey?.journeyId) return;

    try {
      const response = await fetch(`https://v3.dhundhoo.com/journey/copy/${journey.journeyId}`, {
        method: "GET",
        headers: {
          "x-dhundhoo-session": window.localStorage.getItem("token") || "session",
        },
      });

      if (response.ok) {
        toast.success("Journey copied to all successfully!");
      } else {
        toast.error("Failed to copy journey.");
      }
    } catch (error) {
      console.error("Error copying journey:", error);
      toast.error("Error occurred while copying journey.");
    }
  };

  const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  const onExcelExport = () => {
    if (selectedJourney) {
      let data =
        '"JourneyId","Journey Name","Journey Type","Start Time","End Time","WorkingDays","Disabled Name","StopId","Stop Name","Stop Time","Latitude","Longitude","Landmark"\n';

      // Agar journey mein filters/stops available hain
      if (selectedJourney.filters && Object.keys(selectedJourney.filters).length > 0) {
        Object.keys(selectedJourney.filters).forEach((filterId) => {
          const filter = selectedJourney.filters[filterId];
          const stopName = filter.tags && filter.tags.length > 0 ? filter.tags[0] : "";
          const latitude = filter.data?.location?.latitude || "";
          const longitude = filter.data?.location?.longitude || "";
          const landmark = filter.tags && filter.tags.length > 1 ? filter.tags[1] : "none";

          data += `"${selectedJourney.journeyId}","${selectedJourney.journeyName}","${selectedJourney.type
            }","${selectedJourney.interval?.startTime}","${selectedJourney.interval?.endTime}","${selectedJourney.workingDays?.join(", ") || ""
            }","${selectedJourney.disabled ? "Yes" : "No"}","${filterId}","${stopName}","${selectedJourney.interval?.startTime
            }","${latitude}","${longitude}","${landmark}"\n`;
        });
      } else {
        // Bina stops/filters ke sirf journey details download karna
        data += `"${selectedJourney.journeyId}","${selectedJourney.journeyName}","${selectedJourney.type
          }","${selectedJourney.interval?.startTime}","${selectedJourney.interval?.endTime}","${selectedJourney.workingDays?.join(", ") || ""
          }","${selectedJourney.disabled ? "Yes" : "No"}","","","","","",""\n`;
      }

      let blob = new Blob(["\ufeff", data], {
        type: isSafari() ? "application/csv" : "text/csv",
      });
      const dateStr = new Date().toISOString().split("T")[0]; // Aaj ki date append karne ke liye
      FileSaver.saveAs(blob, `Journey_Detail_${dateStr}.csv`);
    }
  };

  const handleCopy = (value) => {
    if (!value) return;
    navigator.clipboard.writeText(value);
  };

  const parsePastedTime = (raw) => {
    if (!raw) return null;
    const text = raw.trim().toLowerCase();

    const match = text.match(/(\d{1,2})(?:[:.](\d{1,2}))?\s*(am|pm)?/);
    if (!match) return null;

    let hours = parseInt(match[1], 10);
    let minutes = match[2] ? parseInt(match[2], 10) : 0;
    const meridiem = match[3];

    if (isNaN(hours) || isNaN(minutes) || minutes > 59) return null;

    if (meridiem === "pm" && hours < 12) hours += 12;
    if (meridiem === "am" && hours === 12) hours = 0;
    if (hours > 23) return null;

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  };

  const handleTimePaste = (field) => (e) => {
    const pastedText = e.clipboardData.getData("text");
    const parsed = parsePastedTime(pastedText);

    e.preventDefault();

    if (parsed) {
      setJourney((prev) => ({ ...prev, [field]: parsed }));
    } else {
      toast.error("Pasted value isn't a valid time (try HH:mm or e.g. 6:30 PM)");
    }
  };

  // Hidden native time input refs — used only to open the picker UI
  const startPickerRef = useRef(null);
  const endPickerRef = useRef(null);

  const openPicker = (ref) => {
    if (ref.current && ref.current.showPicker) {
      ref.current.showPicker();
    }
  };

  const handlePickerChange = (field) => (e) => {
    if (e.target.value) {
      setJourney((prev) => ({ ...prev, [field]: e.target.value }));
    }
  };

  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: "#fff",
        p: 3,
        pb: 10,
        borderRadius: "24px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        maxHeight: "100vh",
        height: "100%",
        overflowY: "auto",
        marginRight: '10px'
      }}
    >
      {isInitializeOpen ? (
        <InitializeJourney thingId={selectedJourney?.thingId || selectedVehicle || "TEST12345"} onInitializeSuccess={handleInitializeSuccess} onBack={handleBack} selectedJourney={selectedJourney} />
      ) : (
        <>

          {selectedJourney && (
            <MDButton
              variant="contained"
              color="warning"
              startIcon={<DownloadIcon />}
              onClick={onExcelExport}
              sx={{ position: "absolute", right: "44px", color: "#fff", zIndex: 1 }}
            >
              Download
            </MDButton>
          )}

          <Typography variant="h6" align="center" mb={3} sx={{
            position: "sticky",
            top: 0,
          }}>
            {selectedJourney
              ? `Update Journey - ${journey.journeyName} (${selectedJourney.thingId})`
              : "Create New Journey"}
          </Typography>

          {selectedJourney && (
            <>
              <Box mb={2}>
                <Typography variant="caption">Journey Id:</Typography>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                  <TextField value={journey.journeyId} disabled fullWidth />
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleCopyToAll}
                    sx={{ whiteSpace: 'nowrap', color: "#000" }}
                  >
                    Copy to All
                  </Button>
                </Box>
              </Box>
              <Box mb={2}>
                <Typography variant="caption">* Journey State:</Typography>
                <TextField value={journey.journeyState} disabled fullWidth />
              </Box>
            </>
          )}

          <Box mb={2}>
            <Typography variant="caption">* Journey Name:</Typography>
            <TextField
              name="journeyName"
              value={journey.journeyName}
              onChange={handleInputChange}
              fullWidth
            />
          </Box>

          <Box mb={2}>
            <Typography variant="caption">* Journey Type:</Typography>
            <MuiSelect
              name="journeyType"
              value={journey.journeyType}
              onChange={(e) => handleInputChange({ target: { name: "journeyType", value: e.target.value } })}
              fullWidth
              sx={{ height: "40px" }}
            >
              <MenuItem value="PICKING">PICKING</MenuItem>
              <MenuItem value="DROPPING">DROPPING</MenuItem>
            </MuiSelect>
          </Box>

          {selectedJourney && (
            <>
              {/* <FormControl component="fieldset" mb={2}>
                <Typography variant="caption">* Journey Status:</Typography>
                <RadioGroup
                  value={!journey.disabled}
                  onChange={(e) => handleToggleChange("disabled")}
                  row
                >
                  <FormControlLabel value={false} control={<Radio />} label="Enable" />
                  <FormControlLabel value={true} control={<Radio />} label="Disable" />
                </RadioGroup>
              </FormControl> */}
              <FormControl component="fieldset" mb={2}>
                <Typography variant="caption">* Journey Status:</Typography>
                <RadioGroup
                  value={journey.journeyStatus ? "true" : "false"}
                  onChange={(e) => setJourney((prev) => ({ ...prev, journeyStatus: e.target.value === "true" }))}
                  row
                >
                  <FormControlLabel value="true" control={<Radio />} label="Enable" />
                  <FormControlLabel value="false" control={<Radio />} label="Disable" />
                </RadioGroup>
              </FormControl>
              <FormControl component="fieldset" mb={2}>
                <Typography variant="caption">* ETA Alerts:</Typography>
                <RadioGroup
                  value={journey.etaAlerts ? "true" : "false"}
                  onChange={(e) => setJourney((prev) => ({ ...prev, etaAlerts: e.target.value === "true" }))}
                  row
                >
                  <FormControlLabel value="true" control={<Radio />} label="Enable" />
                  <FormControlLabel value="false" control={<Radio />} label="Disable" />
                </RadioGroup>
              </FormControl>
              <FormControl component="fieldset" mb={2}>
                <Typography variant="caption">* Geofence Alerts:</Typography>
                <RadioGroup
                  value={!journey.geofenceAlerts}
                  onChange={(e) => handleToggleChange("geofenceAlerts")}
                  row
                >
                  <FormControlLabel value={false} control={<Radio />} label="Enable" />
                  <FormControlLabel value={true} control={<Radio />} label="Disable" />
                </RadioGroup>
              </FormControl>
              <FormControl component="fieldset" mb={2}>
                <Typography variant="caption">* Update Alerts:</Typography>
                <RadioGroup
                  value={!journey.updateAlerts}
                  onChange={(e) => handleToggleChange("updateAlerts")}
                  row
                >
                  <FormControlLabel value={false} control={<Radio />} label="Enable" />
                  <FormControlLabel value={true} control={<Radio />} label="Disable" />
                </RadioGroup>
              </FormControl>
            </>
          )}

          <Box mb={2}>
            <Typography variant="caption">* Time Zone:</Typography>
            <MuiSelect
              name="timeZone"
              value={journey.timeZone}
              onChange={(e) => handleInputChange({ target: { name: "timeZone", value: e.target.value } })}
              fullWidth
              sx={{ height: "40px" }}
            >
              <MenuItem value="Asia/Kolkata">Asia/Kolkata</MenuItem>
              <MenuItem value="UTC">UTC</MenuItem>
              <MenuItem value="America/New_York">America/New_York</MenuItem>
            </MuiSelect>
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Box mb={2}>
                <Typography variant="caption">* Start Time:</Typography>

                <Box display="flex" alignItems="center">
                  <TextField
                    type="text"
                    name="startTime"
                    value={journey.startTime}
                    onChange={handleInputChange}
                    onPaste={handleTimePaste("startTime")}
                    placeholder="HH:mm"
                    fullWidth
                  />

                  <Tooltip title="Open time picker">
                    <IconButton onClick={() => openPicker(startPickerRef)}>
                      <AccessTimeIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Copy">
                    <IconButton onClick={() => handleCopy(journey.startTime)}>
                      <ContentCopyIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  {/* Hidden native picker — only used to visually pick a time */}
                  <input
                    ref={startPickerRef}
                    type="time"
                    value={journey.startTime}
                    onChange={handlePickerChange("startTime")}
                    style={{ position: "absolute", width: 0, height: 0, opacity: 0, pointerEvents: "none" }}
                  />
                </Box>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box mb={2}>
                <Typography variant="caption">* End Time:</Typography>

                <Box display="flex" alignItems="center">
                  <TextField
                    type="text"
                    name="endTime"
                    value={journey.endTime}
                    onChange={handleInputChange}
                    onPaste={handleTimePaste("endTime")}
                    placeholder="HH:mm"
                    fullWidth
                  />

                  <Tooltip title="Open time picker">
                    <IconButton onClick={() => openPicker(endPickerRef)}>
                      <AccessTimeIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Copy">
                    <IconButton onClick={() => handleCopy(journey.endTime)}>
                      <ContentCopyIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <input
                    ref={endPickerRef}
                    type="time"
                    value={journey.endTime}
                    onChange={handlePickerChange("endTime")}
                    style={{ position: "absolute", width: 0, height: 0, opacity: 0, pointerEvents: "none" }}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Box mb={2}>
            <Typography variant="caption">Add Attendant:</Typography>
            <TextField
              name="attendants"
              value={journey.attendants.join(", ")}
              onChange={(e) =>
                setJourney((prev) => ({
                  ...prev,
                  attendants: e.target.value.split(", ").filter(Boolean),
                }))
              }
              fullWidth
            />
          </Box>

          <Box mb={2}>
            <Typography variant="caption">* Working Days:</Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 1 }}>
              {["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"].map(
                (day) => (
                  <Box key={day} sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <Checkbox
                      checked={journey.workingDays.includes(day)}
                      onChange={() => handleWorkingDaysChange(day)}
                    />
                    <Typography>{day}</Typography>
                  </Box>
                )
              )}
            </Box>
          </Box>

          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <Button variant="contained" color="info" onClick={handleSubmit}>
              {selectedJourney ? "UPDATE JOURNEY" : "CREATE JOURNEY"}
            </Button>

            {selectedJourney && (
              <>
                <Button variant="contained" color="info" onClick={onEditStops}>
                  Edit stops
                </Button>
                <Button variant="contained" color="info" onClick={handleReInitialize}>
                  Re-Initialize
                </Button>
                <Button variant="contained" color="info" onClick={handleClearJourney}>
                  Clear
                </Button>
                <Button variant="contained" color="error" onClick={handleChangeThing}>
                  Change Thing
                </Button>
                <Button variant="contained" color="error" onClick={() => setIsDeleteDialogOpen(true)}>
                  Remove
                </Button>
              </>
            )}
          </Box>

          {selectedJourney && (
            <Dialog open={isChangeThingOpen} onClose={handleChangeThingClose}>
              <DialogTitle>Move Journey to other thing</DialogTitle>
              <DialogContent>
                <TextField
                  autoFocus
                  margin="dense"
                  label="New thing id"
                  type="text"
                  fullWidth
                  value={newThingId}
                  onChange={handleNewThingIdChange}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleChangeThingClose} color="info" variant="contained">
                  Cancel
                </Button>
                <Button onClick={handleChangeThingConfirm} color="info" variant="contained">
                  OK
                </Button>
              </DialogActions>
            </Dialog>
          )}
          <Dialog
            open={isDeleteDialogOpen}
            onClose={() => setIsDeleteDialogOpen(false)}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle>Delete Journey</DialogTitle>
            <DialogContent>
              <Typography>
                Are you sure you want to delete this journey?
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setIsDeleteDialogOpen(false)}
                color="info"
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                onClick={handleDeleteJourney}
                color="error"
                variant="contained"
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </Box>
  );
};

export default JourneyForm;